import { render, staticRenderFns } from "./EstimatedDetails.vue?vue&type=template&id=a2de2e44"
import script from "./EstimatedDetails.vue?vue&type=script&lang=js"
export * from "./EstimatedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports